import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Terms from "./pages/Terms";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
